<template>
  <base-table-wrapper v-if="$route.name === 'EXCMAgreementList'">
    <template #top-buttons>
      <div v-if="ableToCreateNewAgreement && !firmIRI" class="float-right">
        <router-link tag="button" :to="{ name: 'EXCMAgreementCreate' }" class="mb-1 btn btn-sm btn-primary">{{ $t('buttons.create') }}</router-link>
      </div>
    </template>
    <template #filtering>
      <b-row>
        <b-col>
          <b-button class="btn-sm float-right" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.userdata_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-collapse id="userdata_search_collapse" class="mt-2">
            <AgreementsFiltering :getPage="getPage"></AgreementsFiltering>
          </b-collapse>
        </b-col>
      </b-row>
    </template>
    <template #body>
      <Table></Table>
    </template>
  </base-table-wrapper>
</template>

<script>
import { mapActions } from 'vuex'
import { checkPagePermission, checkPermission } from '@/utils/checkRoles.js'
import getId from '@/utils/getIdFromLink'
import AgreementsFiltering from './components/AgreementsFiltering/AgreementsFiltering'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import Table from '@/components/Dashboard/Views/excmagreement/Table'

export default {
  components: {
    AgreementsFiltering,
    Table,
    BaseTableWrapper
  },

  props: {
    firmIRI: {
      type: String,
      default: null
    }
  },

  computed: {
    ableToCreateNewAgreement: function () {
      return this.checkRoles('agreements', 'EXCMAgreementCreate')
    },
    mobileView () {
      return this.$store.state.mobileView
    }
  },

  beforeCreate () {
    checkPagePermission('agreements', 'EXCMAgreementList')
  },

  methods: {
    getList () {
      let url = 'e_x_c_m_agreements?_page=1&state=1'
      if (this.firmIRI) {
        url += '&company=' + this.getIdLink(this.firmIRI)
      }
      this.getPage(url)
    },
    ...mapActions({
      getPage: 'excmagreement/list/default'
    }),
    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    },
    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
